var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.39844V9.39844C8.5 9.66365 8.39464 9.91801 8.20711 10.1055C8.01957 10.2931 7.76522 10.3984 7.5 10.3984H2C1.73478 10.3984 1.48043 10.2931 1.29289 10.1055C1.10536 9.91801 1 9.66365 1 9.39844V3.89844C1 3.63322 1.10536 3.37887 1.29289 3.19133C1.48043 3.00379 1.73478 2.89844 2 2.89844H5",
    stroke: "#0D85FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.39844H10V4.39844",
    stroke: "#0D85FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.89844L10 1.39844",
    stroke: "#0D85FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutIcon);
export default __webpack_public_path__ + "static/media/outIcon.d0c1b59285d4640239d0774785474861.svg";
export { ForwardRef as ReactComponent };